import React from 'react';
import { Container } from './styles';

const FormContainer = ({ children }) => <Container>{children}</Container>;

export default FormContainer;
